// Utitlities
import createServiceAsyncThunk from "../../../utils/reduxUtils/createServiceAsyncThunk";
import createGenericSlice from "../../../utils/reduxUtils/createEntitySlice";

// Service
import { educations } from "../../../Api/Services/EducationService/index"; // Importing the educations service for API calls

// Constants
import { ERROR_MESSAGES } from "../../../constants/error";
import { ACTION_NAMES, SLICE_NAMES } from "../../../constants/action";

/**
 * Async thunk to fetch education list.
 * Dispatches an API call to retrieve the education list.
 */
export const fetchEducationListAsyncThunk = createServiceAsyncThunk<any, any>(
  ACTION_NAMES.FETCH_EDUCATION_LIST, // Action Name
  () => educations.getAllEducations(), // API Call
  ERROR_MESSAGES.EDUCATION_LIST_FETCH_FAILURE // Error Message
);

/**
 * Slice to manage the state of education list.
 * Includes actions to clear errors and handle async states.
 */
const educationListSlice = createGenericSlice<any, any>(
  SLICE_NAMES.EDUCATION_LIST, // Slice Name
  fetchEducationListAsyncThunk // Async Thunk
);

// Export the actions to be dispatched in components
export const { clearError: clearEducationListError } =
  educationListSlice.actions;

// Export the reducer function to be included in the Redux store
export default educationListSlice.reducer;
